import React from "react";

export default function Contact() {
    return (
        <div>
            <h1>Estamos en Contact</h1>
        </div>
    );
}